/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PastiNonOrdinariStudenti { 
    identificativo_menu?: string;
    pasta_in_bianco?: boolean;
    numero_pasti?: number;
}

